import { styled as i } from "styled-components";
const e = i.div`
  position: relative;
  display: flex;

  > :first-child {
    position: absolute;
    left: 0;
    top: 0;
    clip-path: ${({ $fillRate: t }) => `inset(0 ${100 - t * 100}% 0 0);)`};
  }
`;
export {
  e as IncompleteStarContainer
};
